import {
  TrackingEvent,
  TrackingEventName,
  TrackingEventSubscription
} from 'shared/experiments/consts'

import trackOptimizelyEvent from './trackOptimizelyEvent'

export const bindTrackingEvents = (
  defs: TrackingEvent[]
): TrackingEventSubscription[] => {
  const subscriptions: TrackingEventSubscription[] = []

  defs.forEach(({ selector, event, trackingEvent, handler }) => {
    document.querySelectorAll<HTMLElement>(selector).forEach(element => {
      const track = () => trackOptimizelyEvent(<TrackingEventName>trackingEvent)

      const eventListener = handler ? (e: Event) => handler(e, track) : track

      element.addEventListener(event, eventListener)
      subscriptions.push({
        element,
        event,
        subscription: eventListener
      })
    })
  })

  return subscriptions
}

export const unscubsribeTracking = (
  subscriptions: TrackingEventSubscription[]
) => {
  subscriptions.forEach(({ element, event, subscription }) =>
    element.removeEventListener(event, subscription)
  )
  // eslint-disable-next-line no-param-reassign
  subscriptions.length = 0
}
